import { ImgProps } from "assets/images/types";

export default function ImgTodasAsFloresFooter2(props: ImgProps) {
	const { height = 277, width = 434 } = props;
	return (
		<img
			src="/assets/images/cases/todas-as-flores/todas-as-flores-footer-2.webp"
			alt="Todas as Flores, uma parceria entre Globoplay e Natura"
			loading="eager"
			width={width}
			height={height}
		/>
	);
}
